export default "__VITE_ASSET__UuNs2TaS__"